<div
  class="flex md:grid md:grid-cols-12 justify-between items-baseline md:pt-2 md:px-4"
>
  <a
    class="to-front inline-block p-2 transform-gpu transition"
    routerLinkActive
    #rla="routerLinkActive"
    [routerLinkActiveOptions]="{ exact: true }"
    [ngClass]="[
      rla.isActive
        ? '-translate-y-2 opacity-0 delay-150 pointer-events-none select-none'
        : ' translate-y-0 opacity-100'
    ]"
    [routerLink]="['/']"
  >
    Stini&nbsp;Roehrs
  </a>
  <nav role="navigation" class="col-span-10">
    <ul
      class="flex flex-wrap md:flex-nowrap justify-end pr-8 md:pr-0 md:justify-center md:space-x-12"
    >
      <li *ngFor="let link of header.navigationMenu">
        <a
          class="inline-block p-2 pb-0 md:pb-2"
          routerLink="{{
            '/' + (link.navigationEntry?.uri || link.category?.uri)
          }}"
          [routerLinkActiveOptions]="{ exact: true }"
          routerLinkActive="italic"
          [innerText]="link.label || link.title"
        >
        </a>
      </li>
    </ul>
  </nav>
</div>
